import SectionPage from '../components/SectionPage';

export default function LeyREP() {
  return (
    <SectionPage
      title="Ley REP"
      intro="Ley de Responsabilidad Extendida del Productor y trazabilidad para residuos gestionados por un gestor autorizado."
      sections={[
        {
          title: '¿Qué establece la ley?',
          id: 'que-establece',
          body: <p>Busca disminuir la generación de residuos y fomentar reutilización, reciclaje y valorización.</p>,
        },
      ]}
    />
  );
}
